import bonusDialogCtrl from "./bonusDialog/bonusDialog.controller";
import bonusDialog from "./bonusDialog/bonusDialog.html";

class Controller {
  constructor(
    $injector,
    $mdDialog,
    $stateParams,
    Events,
    InvoiceItem,
    ActionLists
  ) {
    "ngInject";

    this.Events = Events;

    this.Invoice = $injector.get("ContractorInvoice");
    this.$mdDialog = $mdDialog;
    this.InvoiceItem = InvoiceItem;
    this.$stateParams = $stateParams;
    this.City = $injector.get("City");
    this.InvoiceTransforms = $injector.get("ContractorInvoiceTransforms");
    this.noteEvent = this.Events.getUpdateEvent("contractorInvoiceNote");
    this.invoiceItemParams = {
      invoice: this.$stateParams.id,
      isCityRequired: false,
    };
    this.invoiceItemFields = this.InvoiceTransforms.invoiceItemFields;
    this.invoiceItemTypes = ["manual_bonus"];
    this.invoiceItemActions = ActionLists.all.invoiceItemActions;
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.$mdDialog.confirm().title("Dialog").ok("Ok").cancel("Cancel");

    const onAddNote = (options) => {
      const note = options.comment.value;

      this.Invoice.addNote(this.$stateParams.id, { note }).$promise.then(
        (response) => {
          this.invoice = this.InvoiceTransforms.justify(response);
          this.Events.emit(showNotificationEvent, {
            message: "Your note added successfully",
          });
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };
    this.InvoiceItem.getTypes({
      category: "contractor_manual_bonus",
    }).$promise.then((response) => {
      this.bonusList = response.hits;
    });

    this.Invoice.get(this.$stateParams.id).$promise.then((response) => {
      this.invoice = this.InvoiceTransforms.justify(response);
    });

    this.Events.on(this.noteEvent, onAddNote);
    this.getSystemCategories();
  }

  manualBonus() {
    this.$mdDialog.show({
      controller: bonusDialogCtrl,
      controllerAs: "$ctrl",
      template: bonusDialog,
      locals: {
        types: this.bonusList,
        invoice: this.$stateParams.id,
        contractor: this.invoice.contractor._id,
        systemCategories: this.systemCategories,
      },
    });
  }

  getSystemCategories() {
    this.systemCategories = [];
    this.City.getRideCategory().$promise.then((response) => {
      if (response.hits) {
        this.systemCategories = response.hits.map(
          ({ _id: id, _source: category }) => ({
            id,
            title: `${category.ride_type} ${category.service_type}`,
          })
        );
      }
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/contractorInvoice/contractorInvoice.controller.js